/**
 * What is still allowed to render ON TOP of a verified user's app (ADR 0006).
 *
 * Only two things are, and for different reasons:
 *
 *   1. `PolicyAcceptanceGate` -- a blocking modal, deliberately. It can hit an
 *      existing user mid-session on a version bump, which is a redirect-from-
 *      anywhere problem, not a post-signup flow.
 *   2. `FeatureTourLayer` -- tours anchor to live UI targets through the
 *      tour-target registry, which is what a tour is.
 *
 * The username claim and onboarding both left this file: they are routes in the
 * `(setup)` group now, so the app shell cannot paint behind them.
 *
 * The tour layer is gated on `gate === 'app'`, NOT on `!needsSetup`. During
 * `booting` there is no setup yet, so a bare negation would let a tour prompt
 * mount while the username screen is still resolving -- the exact reported bug.
 */

import { FeatureTourLayer } from '@/features/feature-tours';
import { PolicyAcceptanceGate, usePolicyAcceptance } from '@/features/policy-acceptance';
import { useAppGate } from '@/features/setup/gate/use-app-gate';

export function VerifiedUserGates() {
  const { status } = usePolicyAcceptance();
  const { gate } = useAppGate();

  return (
    <>
      <PolicyAcceptanceGate />
      {status === 'clear' && gate === 'app' && <FeatureTourLayer />}
    </>
  );
}
